<template lang="html">
  <svg class="icon-svg-paper-top" width="353" height="8" viewBox="0 0 353 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M352.561 0L344.174 5.6L335.779 0L327.393 5.6L319.006 0L310.629 5.6L302.242 0L293.865 5.6L285.478 0L277.101 5.6L268.714 0L260.328 5.6L251.95 0L243.564 5.6L235.186 0L226.8 5.6L218.422 0L210.036 5.6L201.658 0L193.281 5.6L184.903 0L176.525 5.6L168.148 0L159.77 5.6L151.393 0L143.015 5.6L134.637 0L126.251 5.6L117.873 0L109.496 5.6L101.109 0L92.7317 6.4L84.3541 0L75.9765 5.6L67.5901 0L59.2125 5.6L50.8349 0L42.4573 5.6L34.0709 0L25.6933 5.6L17.3157 0L8.93815 5.6L0.560547 0V8H352.561V0Z" fill="#F7F3F2"/>
  </svg>

</template>
<script>
    export default {
        name: 'IconPaperTop'
    }
</script>



// WEBPACK FOOTER //
// src/components/IconPaperTop.vue